export const BLOCK_REFERENCE_MENTION = 'block_reference';
